var _rect, _rect2, _rect3, _path, _rect4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmallTablet = function SvgSmallTablet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 48,
    rx: 5,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 54,
    height: 33,
    rx: 3,
    fill: "#C7DFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 41,
    width: 18,
    height: 3,
    rx: 1.5,
    fill: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 19H36V14.5V14C36 11.7909 34.2091 10 32 10C29.7909 10 28 11.7909 28 14V19Z",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9686 25.7502C33.5837 25.4091 34 24.7532 34 24C34 22.8954 33.1046 22 32 22C30.8954 22 30 22.8954 30 24C30 24.7532 30.4163 25.4091 31.0314 25.7502C31.0109 25.8301 31 25.9138 31 26V28C31 28.5523 31.4477 29 32 29C32.5523 29 33 28.5523 33 28V26C33 25.9138 32.9891 25.8301 32.9686 25.7502Z",
    fill: "#413D45"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmallTablet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small-tablet.a24cc169f4c74d9bbf4bc5fc9a25c0e4.svg";